import React from 'react';

import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';

import styles from './SkeletonCourseCard.module.css';

const SkeletonCourseCard = ({ isSingle = false }) => {
    return (
        <article
            className={`
                ${styles.courseBoxCard}
                ${isSingle ? styles.singleCourseBoxCard : ''}
            `}
        >
            {/* =========================
                IMAGE SECTION
            ========================= */}
            <div className={styles.imageWrapper}>
                <Skeleton
                    className={styles.imageSkeleton}
                    containerClassName={styles.imageSkeletonContainer}
                />

                {/* Featured badge */}
                <div className={styles.featureBadgeSkeleton}>
                    <Skeleton
                        width={72}
                        height={12}
                        borderRadius={999}
                    />
                </div>

                {/* Only shown in single course design */}
                {isSingle && (
                    <div className={styles.heroTagsSkeleton}>
                        <Skeleton
                            width={78}
                            height={25}
                            borderRadius={999}
                        />

                        <Skeleton
                            width={68}
                            height={25}
                            borderRadius={999}
                        />
                    </div>
                )}
            </div>

            {/* =========================
                DETAILS
            ========================= */}
            <div className={styles.detailscard}>
                <div className={styles.courseDetails}>

                    {/* Popular / New */}
                    <div className={styles.metaRow}>
                        <Skeleton
                            width={82}
                            height={23}
                            borderRadius={999}
                        />

                        <Skeleton
                            width={48}
                            height={23}
                            borderRadius={999}
                        />
                    </div>

                    {/* Course Title */}
                    <div className={styles.titleSkeleton}>
                        <Skeleton
                            height={23}
                            width="88%"
                        />

                        {isSingle && (
                            <Skeleton
                                height={23}
                                width="58%"
                            />
                        )}
                    </div>

                    {/* Description */}
                    <div className={styles.descriptionSkeleton}>
                        <Skeleton
                            height={13}
                            width="100%"
                        />

                        <Skeleton
                            height={13}
                            width="96%"
                        />

                        <Skeleton
                            height={13}
                            width="90%"
                        />

                        {isSingle && (
                            <>
                                <Skeleton
                                    height={13}
                                    width="94%"
                                />

                                <Skeleton
                                    height={13}
                                    width="68%"
                                />
                            </>
                        )}
                    </div>

                    {/* Mentor */}
                    <div className={styles.mentorRow}>
                        <Skeleton
                            width={52}
                            height={12}
                        />

                        <Skeleton
                            width={125}
                            height={15}
                        />
                    </div>

                    {/* Students / Duration */}
                    <div className={styles.iconRow}>
                        <div className={styles.statSkeleton}>
                            <Skeleton
                                circle
                                width={15}
                                height={15}
                            />

                            <Skeleton
                                width={42}
                                height={14}
                            />
                        </div>

                        <div className={styles.statSkeleton}>
                            <Skeleton
                                circle
                                width={15}
                                height={15}
                            />

                            <Skeleton
                                width={65}
                                height={14}
                            />
                        </div>
                    </div>

                    {/* Price / Button */}
                    <div className={styles.bottomRow}>
                        <div className={styles.priceBlock}>
                            <Skeleton
                                width={105}
                                height={20}
                            />

                            <Skeleton
                                width={72}
                                height={13}
                            />
                        </div>

                        <Skeleton
                            width={115}
                            height={40}
                            borderRadius={999}
                            className={styles.buttonSkeleton}
                        />
                    </div>

                </div>
            </div>
        </article>
    );
};

export default SkeletonCourseCard;